var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', [_vm._v("Markeer de legplaats als voltooid.")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('success');
      }
    }
  }, [_vm._v("Voltooid")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }